import React, { useEffect, useState } from "react";

const LEGAL_PAGES = {
  privacidad: { title: "Política de Privacidad", file: "/politica_privacidad.txt" },
  privacy: { title: "Política de Privacidad", file: "/politica_privacidad.txt" },
  aviso: { title: "Aviso Legal", file: "/aviso_legal.txt" },
  cookies: { title: "Política de Cookies", file: "/politica_de_cookies.txt" },
  condiciones: { title: "Condiciones de Uso", file: "/condiciones_de_uso.txt" },
};

export default function LegalPage({ type }) {
  const [content, setContent] = useState("");
  const page = LEGAL_PAGES[type] || LEGAL_PAGES.privacidad;

  useEffect(() => {
    fetch(page.file)
      .then((res) => res.text())
      .then((text) => setContent(text))
      .catch(() => setContent("No se pudo cargar el documento."));
  }, [page.file]);

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        <h1>{page.title}</h1>
        <div className="privacy-policy-content">
          {content.split("\n").map((line, i) => (
            <p key={i}>{line || "\u00A0"}</p>
          ))}
        </div>
        <div className="privacy-policy-footer">
          <p>EV Route Planner &copy; {new Date().getFullYear()}</p>
          <a href="/" className="privacy-back-link">← Volver a la aplicación</a>
        </div>
      </div>
    </div>
  );
}
